import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, Users, ArrowUpRight } from "lucide-react";

const tabs = [
  {
    label: "Exit Management",
    path: "/admin/exit",
    icon: LogOut,
    color: "#EF4444", // red
    desc: "Employee Exit",
  },
  {
    label: "Interview Rounds",
    path: "/admin/interview-rounds-setup",
    icon: Users,
    color: "#22C55E", // green
    desc: "Interview Flow",
  },
];

export default function HiringRecruitmentDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="p-8 bg-[#fafafa] min-h-screen font-roboto">
      {/* HEADER */}
      <h1 className="text-2xl font-black font-poppins mb-6 text-slate-900">
        Hiring & Recruitment
      </h1>

      {/* GRID */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;

          return (
            <div
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`
                cursor-pointer rounded-2xl p-4 h-40
                border flex flex-col justify-between
                transition-all duration-200
                ${isActive ? "scale-[1.03]" : "hover:-translate-y-0.5"}
              `}
              style={{
                backgroundColor: isActive ? tab.color : "#ffffff",
                borderColor: isActive ? tab.color : "#e5e7eb",
                boxShadow: isActive
                  ? `0 20px 40px -15px ${tab.color}AA`
                  : "0 6px 16px rgba(0,0,0,0.08)",
              }}
            >
              {/* TOP */}
              <div className="flex justify-between items-start">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{
                    backgroundColor: isActive
                      ? "rgba(255,255,255,0.2)"
                      : `${tab.color}15`,
                    color: isActive ? "#ffffff" : tab.color,
                  }}
                >
                  <Icon size={20} strokeWidth={2.5} />
                </div>

                <ArrowUpRight
                  size={16}
                  className={isActive ? "text-white" : "text-slate-300"}
                />
              </div>

              {/* TEXT */}
              <div>
                <h3
                  className={`text-sm font-black font-poppins tracking-tight ${
                    isActive ? "text-white" : "text-slate-800"
                  }`}
                >
                  {tab.label}
                </h3>
                <p
                  className={`text-[11px] font-bold uppercase tracking-tighter ${
                    isActive ? "text-white/80" : "text-slate-400"
                  }`}
                >
                  {tab.desc}
                </p>
              </div>

              {/* ACTIVE DOT */}
              {isActive && (
                <div className="absolute top-2 right-2 w-2 h-2 bg-white rounded-full animate-pulse" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
